<template lang="pug">
div.table-responsive     
    modal(v-show="IsShowImg",:titulo="'Imagen : ' + selectImg.question" bindClass="col-md-7 col-sm-12" , @close="IsShowImg=false")
        div(slot='body') 
             img(:src="'data:image/png;base64,' + selectImg.img.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,','')")     
    .form-group 
        v-card
            v-card-title(class="elevation-1") 
                h4 {{InfoSelect.Name}}
                div(v-show="false") {{IdDocType_}}   
                v-spacer
                v-text-field(v-model="search" label="Busqueda...." class="mx-5" append-icon="mdi-magnify")
                v-btn(color="success" @click="exportar('Documentos')") Exportar
                    i.fa.fa-plus-excel-o
            v-container( fluid)
                v-data-table(       
                        id="DocumentoTabla"   
                        :headers="tableHeadTest"                 
                        :items="tableInfo"
                        :items-per-page="1000"
                        class="elevation-1"
                        :search="search" 
                        style="font-size: 14px;" )
                    template( v-slot:body="{ items }") 
                        tr(v-for="(row,index)  in items")    
                            td(v-for="(value,column) in  row")                               
                                div(v-if="column!='questions' && column.toLowerCase().indexOf('img')>=0") 
                                    img(v-if="value!='' && value!=null", height="60" @click="selectImg.img=value; selectImg.question=row.question; IsShowImg=true" :src="'data:image/png;base64,' + value.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,','')") 
                                div(v-else-if="column != 'questions' && isDate(value)") {{ formatDate(value) }}
                                div(v-else-if="column!='questions'") {{value}} 
            //- v-simple-table(dense  :search="search" class="elevation-2")
            //-     thead.bg-table.text-white
            //-         th(v-if="tableHead.length ", v-for="item in tableHead")
            //-             div(v-if="item=='idDocumentDetails'") Accion  
            //-             div(v-else) {{item}}                 
            //-     tbody.bg-white(name="table-fade", is="transition-group") 
            //-         tr(v-if="tableInfo.length", v-for="(row,index) in tableInfo", :key="index")  
            //-             td(v-for="(value,column) in  row")                               
            //-                 div(v-if="column!='questions' && column.toLowerCase().indexOf('img')>=0") 
            //-                     img(v-if="value!='' && value!=null", height="60" @click="selectImg.img=value; selectImg.question=row.question; IsShowImg=true" :src="'data:image/png;base64,' + value.replace('data:image/png;base64,','').replace('data:image/jpeg;base64,','')") 
            //-                 div(v-else-if="column!='questions'") {{value}}                                            

</template>
<script>
import modal from "../../../../complementos/modal.vue" 
import model from "../../../../models/docQuestionsCategory.js" 
import exportExcel from '../../../..//tools/exportExcel.js'
import { EventBus } from "../../../../complementos/event-bus.js";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
export default {
    props:{   
        InfoSelect:Object, 
        apiWeb:Object, 
    },  
    data(){
        return{ 
            pathApi:'Report/', 
            IsShowImg:false, 
            typeAccount:0,
            selectImg:{img:'',question:''}, 
            DocumentSelect:{},
            IdDocTypeOld_:0,
            tableInfo:[],
            tableHead:{},
            tableHeadTest:[],
            tableInfoDetalis:[],
            tableHeadDetalis:{},
            search:''
        }
    },
    created(){
         this.typeAccount=this.$info.typeAccount
    },
    components:{
        modal         
    },
    computed:{
        isShowModal_ :{
                        get(){
                            this.List_Info()  
                            return this.IsShowModal 
                        },
                        set(val){
                            this.List_Info()  
                            this.$emit("update:IsShowModal",val)
                        }
        },
        IdDocType_ :{
                        get(){
                            if(this.IdDocTypeOld_!=this.InfoSelect.IdDocType){
                                this.IdDocTypeOld_=this.InfoSelect.IdDocType
                                this.List_Info()                                
                            }                                
                            return this.InfoSelect.IdDocType
                        },
                        set(val){ 
                           
                        }
        } 
    }, 
    methods:{
         // stolen object parser to date //
         formatDate(date) {
            if (!date) return '';
        
        if (date instanceof Date) {
            date = date.toISOString();
        }
        if (typeof date === 'string') {
            const parts = date.split('T')[0].split('-');
            if (parts.length === 3) {
                return `${parts[2]}/${parts[1]}/${parts[0]}`;
            }
        }

        return date; 
        },
        isDate(value) {
        return !isNaN(Date.parse(value));
        },
        ///
        ValidateValor(v){
            console.log(v)
        },
        IsEdit(val){
            val=val==0 ? 1:0;
            console.log(val)
        } , 
        List_Info(){               
            this.apiWeb.get(this.pathApi + "ReportDocumentDetails_NON_CONFORMING_Clousure/"+ this.$info.email   +"/"+ this.IdDocType_,"")
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(JSON.stringify(result.value))         
                                    console.log(JSON.stringify(result.value) )
                                    console.log(result.value)
                                    console.log( this.tableInfo)
                                    this.tableHeadTest=[]
                                    if( this.tableInfo.length>0)
                                    {
                                       this.tableHead=Object.keys(this.tableInfo[0])     
                                       this.tableHead.forEach(element => {
                                            this.tableHeadTest.push({text: element.capitalize(), value:element})    
                                       });    
                                    }                                   
                                                                
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }, 
        
        exportar(title){ 
                               EventBus.$emit("loading", true)
                            exportExcel.exportToExcel(title,this.tableInfo) 
                            EventBus.$emit("loading", false)
        },
        
    }

    
}
</script>